import { EMPTY_OBJECT } from 'commons-ui';
import _noop from 'lodash/noop';
import { EAbExpActions } from '../utils/constants';

type Action = {
	id: string;
	isEnabled: () => boolean;
	name: string;
};

type ActionHandlerParams = {
	history: any;
	rowData: any;
};
export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case EAbExpActions.add:
			return () => {
				history.push({
					pathname: `/dashboard/abTest/create`
				});
			};
		case EAbExpActions.edit:
			return () => {
				history.push({
					pathname: '/dashboard/abTest/edit',
					state: {
						rowData
					}
				});
			};
		case EAbExpActions.buckets:
			return () => {
				history.push({
					pathname: '/dashboard/abTest/bucketDetails',
					state: {
						rowData
					}
				});
			};
		case EAbExpActions.versionHistory:
			return () => {
				history.push({
					pathname: '/dashboard/abTest/versionHistory',
					state: {
						rowData
					}
				});
			};
		case EAbExpActions.versionList:
			return () => {
				history.push({
					pathname: '/dashboard/abTest/versionList',
					state: {
						rowData
					}
				});
			};
		case EAbExpActions.fixUsersBucket:
			return () => {
				history.push({
					pathname: '/dashboard/abTest/fixUsersBucket',
					state: {
						rowData
					}
				});
			};
		case EAbExpActions.findUserBucket:
			return () => {
				history.push({
					pathname: '/dashboard/abTest/findUserBucket',
					state: {
						rowData
					}
				});
			};
		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
